import CancellationReasonsModel from 'models/CancellationReasons'

class PolicyCancellationReasonsDto {
    static fromJson(dataFromAPI) {
        const data = Object.entries(dataFromAPI).map(([id, value]) => ({ id, value }))

        return new CancellationReasonsModel(data)
    }
}

export default PolicyCancellationReasonsDto
